var Field = /** @class */ (function () {
    function Field(rawField) {
        this.id = '';
        this.key = '';
        this.value = '';
        if (!rawField)
            return;
        var id = rawField.id, key = rawField.key, value = rawField.value;
        this.id = id;
        this.key = key;
        this.value = value;
    }
    return Field;
}());
export default Field;
//# sourceMappingURL=Field.js.map